<div class="progress-bg border-radius-4 my-1 bg-light-gray cursor-pointer"
     [appUITooltip]="true"
     [placement]="'top'"
     [trigger]="'hover'"
     i18n-ttitle="@@app.available_modules_progress_bar_tooltip"
     ttitle="''"
     [dynamicTitle]="progressValue | getAvailableModulesText : availableModulesText">
  <div [ngStyle]="{'width' : (progressValue ? progressValue : 0) + '%'}"
       [ngClass]="(progressValue | isProgressAboveLimit : progressLimit) ? 'bg-red' : 'bg-brand'"
       class="actual-progress border-radius-4"></div>
  <div #availableModulesText i18n-title="@@app.available_modules_progress_bar_tooltip" title="Available Modules"></div>
</div>
